import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { BlogPost } from "@/data/blogPosts";
import { ArrowRight, LucideIcon } from "lucide-react";

interface CapsuleCardProps {
  id?: string;
  icon: LucideIcon;
  title: string;
  description: string;
  difficulty: "Fácil" | "Media" | "Avanzada";
  timeToImplement: string;
  relatedPosts: BlogPost[];
}

const CapsuleCard = ({ 
  id,
  icon: Icon, 
  title, 
  description, 
  difficulty, 
  timeToImplement, 
  relatedPosts 
}: CapsuleCardProps) => {
  return (
    <Card className="group relative overflow-hidden border border-white/10 bg-black text-white backdrop-blur-xl shadow-lg hover:shadow-xl transition-all duration-500 hover:-translate-y-2 flex flex-col h-full">
      <CardHeader className="space-y-6 pb-8">
        <Icon className="h-10 w-10 text-white/80" />
        <CardTitle className="text-2xl font-extralight text-white tracking-tight leading-tight">
          {title}
        </CardTitle>
        <CardDescription className="text-base font-light text-white/60 leading-relaxed">
          {description}
        </CardDescription>
      </CardHeader>
      
      <CardContent className="flex-1 space-y-8">
        {/* Related Posts */}
        <div className="space-y-4 pt-4 border-t border-white/10">
          <h4 className="text-xs font-light text-white/40 uppercase tracking-wider">
            Cápsulas relacionadas
          </h4>
          <ul className="space-y-3">
            {relatedPosts.slice(0, 3).map((post) => (
              <li key={post.id}>
                <Link 
                  to={`/blog/${post.slug}`}
                  className="text-sm font-light text-white/60 hover:text-white flex items-start gap-3 group/link transition-colors duration-300"
                >
                  <ArrowRight className="h-4 w-4 mt-0.5 flex-shrink-0 opacity-0 -translate-x-2 group-hover/link:opacity-100 group-hover/link:translate-x-0 transition-all duration-300" />
                  <span className="line-clamp-2">{post.title}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </CardContent>
      
      <CardFooter className="pt-8">
        <Button 
          variant="ghost" 
          className="w-full text-white/60 hover:text-white hover:bg-white/10 font-light border-none" 
          asChild
        >
          <Link to={id ? `/capsulas/${id}` : "/capsulas"} className="flex items-center justify-center gap-2">
            <span>Ver cápsula completa</span>
            <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
};

export default CapsuleCard;
